/**
 * The time wheel under «Начало» / «Конец» on sheets 15a and 16a (the mockup's
 * .wheel): half-hour steps (D-61), five rows visible, the chosen one centred.
 */
import { useEffect, useRef } from 'react';

export const HALF_HOURS = Array.from({ length: 48 }, (_, i) => `${String(Math.floor(i / 2)).padStart(2, '0')}:${i % 2 ? '30' : '00'}`);

export function Wheel({ value, onChange, label }: { value: string; onChange: (hm: string) => void; label: string }) {
  const box = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = box.current?.querySelector<HTMLElement>('.on');
    if (el && box.current) box.current.scrollTop = el.offsetTop - box.current.clientHeight / 2 + el.clientHeight / 2;
  }, [value]);
  return (
    <div ref={box} className="wheel tnum" role="listbox" aria-label={label} style={{ maxHeight: 178, overflowY: 'auto', position: 'relative' }}>
      {HALF_HOURS.map((hm) => (
        <div key={hm} role="option" aria-selected={hm === value} className={hm === value ? 'on' : ''} onClick={() => onChange(hm)} style={{ cursor: 'pointer' }}>
          {hm}
        </div>
      ))}
    </div>
  );
}
